<template>
  <div class="mt-5 mx-5">
    <paywall :feature-type="FEATURE_TYPE.BOOLEAN">
      <div slot="heading">Start with <i>why</i>, write your Vision and Mission statements</div>
      <div slot="content">
        An team aligned with purpose is much more motivated as they can see the bigger picture.
      </div>
    </paywall>
  </div>
</template>

<script>
import { trackAnalyticsEvent } from '@/analytics'
import Paywall from '@/components/paywalls/Paywall.vue'
import { EVENT_ACTION, EVENT_CATEGORY } from '@/constants/analytics'
import { FEATURE_TYPE } from '@/constants/featureFlags'

/**
 * This is the paywall for vision feature
 */
export default {
  name: 'VisionPaywall',
  props: [],
  components: {
    Paywall
  },
  data() {
    return {
      FEATURE_TYPE
    }
  },
  computed: {},
  methods: {},
  mounted() {
    trackAnalyticsEvent(EVENT_CATEGORY.UPGRADES, EVENT_ACTION.PAYWALL_CLICKED, {
      paywall: 'Vision'
    })
  }
}
</script>
